import { TableCell, tableCellClasses, styled } from '@mui/material';

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: 8,
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontSize: 16
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14
  }
}));

export default StyledTableCell;
